import React from "react";

import {
    ComparisonCard as CardValue,
    ComparisonCardsBlock as Value,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Carousel } from "../GoodcookCarousel";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    id?: string;
}

const ComparisonCard = ({ image, title, pill_heading, pills }: CardValue) => (
    <div className={styles.card}>
        {image && (
            <ImageChooserBlock
                value={image}
                sizes="(max-width: 767px) 100vw, 33vw"
                imageAttrs={{ className: styles.image }}
            />
        )}
        {title && <p className={styles.title}>{title}</p>}
        {pill_heading && <p className={styles.pillHeading}>{pill_heading}</p>}
        {pills && pills.length > 0 && (
            <ul className={styles.list}>
                {pills.map((pill, index) => (
                    <li key={`pill-${index}`} className={styles.listItem}>
                        {pill}
                    </li>
                ))}
            </ul>
        )}
    </div>
);

export const ComparisonCardsBlock = ({ value, id }: Props) => {
    if (!value.cards || value.cards.length === 0) return <></>;

    return (
        <Carousel
            label={value.block_label!}
            containerProps={{ className: styles.root }}
            scrollContainerProps={{ className: styles.carousel }}
            advanceBy="item"
        >
            {value.cards.map((card, index) => (
                <ComparisonCard key={`testimonials-${id}-${index}`} {...card} />
            ))}
        </Carousel>
    );
};
